import React, { Component } from 'react';
import { observer } from 'mobx-react';
import SystemTranslationProgress from './SystemTranslationProgress';
import { browserHistory } from 'react-router';
import PropTypes from 'prop-types';
import SystemTranslationEmailTemplateProgressService from '../services/SystemTranslationEmailTemplateProgressService';

class SystemTranslationEmailTemplateProgressContainer extends Component {
  systemTranslationEmailTemplateProgressService = new SystemTranslationEmailTemplateProgressService();

  componentDidMount() {
    this.systemTranslationEmailTemplateProgressService.init(this.props.locale);
  }

  render() {
    return (
      <SystemTranslationProgress
        title="Email Templates"
        percentage={this.systemTranslationEmailTemplateProgressService.progress.percentage}
        total={this.systemTranslationEmailTemplateProgressService.progress.translated}
        fetching={this.systemTranslationEmailTemplateProgressService.fetch.fetching}
        onClick={() =>
          browserHistory.push({
            pathname: '/email-templates',
            query: { localeMissingTemplate: this.props.locale.key },
            state: { from: { text: 'System Translations', pathname: '/system-translations' } },
          })
        }
      />
    );
  }
}

SystemTranslationEmailTemplateProgressContainer.propTypes = {
  locale: PropTypes.shape({
    key: PropTypes.string.isRequired,
    language: PropTypes.string.isRequired,
  }).isRequired,
};

export default observer(SystemTranslationEmailTemplateProgressContainer);
